import { Validator } from "devextreme-react";
import { PatternRule, RequiredRule } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callOperation } from "async-ops";
import MdaeDateBox from "../../common_components/common_widgets/date-box";
import MdaeSelectBox from "../../common_components/common_widgets/select-box/component";
import MdaeTextArea from "../../common_components/common_widgets/text-area";
import MdaeTagBox from "../../common_components/common_widgets/tag-box";
import {
  PROFESSIONAL,
  CLAIM_TYPE,
  TARGET_TYPE,
  TARGET_VALUE,
  COMPLETED_SATUS,
} from "./constants";
import { auditModes } from "./constants";
import {
  SET_TARGET_TYPES_LOOKUP,
  SET_AUDIT_PROPERTIES_DATA,
  SET_TARGET_TYPE_VALUE_DATA_SOURCE,
  SET_TARGET_TYPE_SELECTION,
  SET_IS_SET_TARGET_CODE_VALUES,
  SET_IS_COMPONENT_LOADED_FLAG,
  SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
  TOGGLE_EDIT_REQUESTER_ALERT_POPUP,
  SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
  SET_VALID_INITIAL_CONTENT_TYPE_LIST,
  sortSelectedItemsOnTop,
  shouldSetClaimType,
  auditRLLODataSource
} from "./reducers/audit-properties-reducer";
import { GET_CODE_TYPES_LOOKUPS } from "./services/get-code-types-lookups";
import $ from "jquery";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../common_components/mdae-common-reducer";
import { GET_EA_REQUESTER_BY_ID } from "./services/get-requester-by-id";
import { GET_TARGET_DATA_LOOKUPS } from "./services/get-target-data-lookups";
import { CustomRule } from "devextreme-react/data-grid";
import { GET_EA_TARGET_VALUE_SOURCES } from "./services/get-ea-target-value-sources";
import ClaimTypeWarningPopup, {
  toggleClaimTypeWarningPopup,
} from "./claim-type-warning-popup";
import { isEmpty, isEqual } from "lodash";
import CustomStore from "devextreme/data/custom_store";
import { SET_CURRENT_ROUND_DATA } from "./reducers/external-audit-reducer";
import "./index.scss";
import { RequiredFieldLabel } from "../../common_components/common_widgets/required-field-label";
import { getUserPermissionObject } from "../../common_components/user-permissions-helper";
import EditRequesterPermissionAlertPopup from "./edit-requester-permission-alert-popup";
import { compareDates } from "../../utils/dateUtils";
import { GET_TARGET_RATIONALE_LOOKUP_DATA } from "./services/get-target-rationale-lookup-data";
import { actions } from "async-ops";
import { handleTargetValueDataSource } from "../../common_components/target-value-datasource-utils";
export const isTargetTypeOfCode = (targetType) => {
  if (
    targetType === "CPTHCPCS" ||
    targetType === "ICDD" ||
    targetType === "ICDP" ||
    targetType === "DRG" ||
    targetType === "APR_DRG" ||
    targetType === "MODIFIER" ||
    targetType === "PROVIDER" ||
    targetType === "FACILITY" ||
    targetType === "RENDERING_PROVIDER_GROUP"
  ) {
    return true;
  }
  return false;
};
export const isPrintableAscii=(value) => {
  if (!value) return true;
  const printableAsciiRegex = /^[\x20-\x7E]*$/;
  return printableAsciiRegex.test(value);
};

export const invalidOrUnprintableCharMassage ="Invalid or un-printable characters, only standard keyboard characters are allowed.";

const AuditPropertiesTargetDataSectionComponent: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const isSetTargetCodeValue = useSelector(
    (state) => state["auditPropertiesReducer"].isSetTargetCodeValue,
    isEqual
  );
  const targetTypeLookup = useSelector(
    (state) => state["auditPropertiesReducer"].targetTypes
  );
  const targetType2Lookup = useSelector(
    (state) => state["auditPropertiesReducer"].targetTypes2
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const isInitialReviewContractorInvalidForRequester = useSelector(
    (state) => state["auditPropertiesReducer"].isInitialReviewContractorInvalidForRequester,
    isEqual
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const requesterPermissions = getUserPermissionObject(
    "REQUESTER",
    currentUser
  );
  const requesterData = useSelector(
    (state: any) => state["auditPropertiesReducer"].requesterData,
    isEqual
  );
  const reviewContractorContentTypeList =  useSelector(
    (state: any) => state["auditPropertiesReducer"].reviewContractorContentTypeList,
    isEqual
  );
  const reviewContractorList =  useSelector(
    (state: any) => state["auditPropertiesReducer"].reviewContractorList,
    isEqual
  );
  const reviewContractors = useSelector(
    (state: any) => state["requesterReducer"].reviewContractors,
    isEqual
  );
  const isInitialContentTypeInvalidForReviewContractor =  useSelector(
    (state: any) => state["auditPropertiesReducer"].isInitialContentTypeInvalidForReviewContractor,
    isEqual
  );
  const patientTypes = useSelector(
    (state) => state["auditPropertiesReducer"].patientTypes,
    isEqual
  );
    const [isTargetTypeOther, setIsTargetTypeOther] = useState(false);
    const [isTargetTypeProvider, setIsTargetTypeProvider] = useState(false);
    const [isTargetTypePatientType, setTargetTypePatientType] = useState(false);
    const [isTargetType2Other, setIsTargetType2Other] = useState(false);
    const [isTargetType2Provider, setIsTargetType2Provider] = useState(false);
    const [isTargetType2PatientType, setTargetType2PatientType] = useState(false);
    const [isTargetType1Selected, setTargetType1Selected] = useState(false);

  const eaAuditTypes = useSelector(
    (state) => state["auditPropertiesReducer"].eaAuditTypes
  );
  const [targetType1Instance, setTargetType1Instance] = useState(null);
  const [
    targetType1CodeValueInstance,
    setTargetType1CodeValueInstance,
  ] = useState(null);
  const [targetType2Instance, setTargetType2Instance] = useState(null);
  const [
    targetType2CodeValueInstance,
    setTargetType2CodeValueInstance,
  ] = useState(null);
  const targetType1ValueSource = useSelector(
    (state) => state["auditPropertiesReducer"].targetType1ValueSource,
    isEqual
  );
  const targetType2ValueSource = useSelector(
    (state) => state["auditPropertiesReducer"].targetType2ValueSource,
    isEqual
  );
  const auditPeriod = useSelector(
    (state) => state["auditPropertiesReducer"].auditPeriod
  );
  const auditTargetRationaleList = useSelector(
    (state) => state["auditPropertiesReducer"].targetRationaleList
  );
  const isAuditSafeToSave = useSelector((state) => {
    const auditStatus = state["auditPropertiesReducer"].auditStatus?.find(
      (x) =>
        x?.statusId ===
        state["auditPropertiesReducer"].auditPropertiesData.statusId
    );
    return (
      props.remainingRequiredFieldsCount === 0 ||
      (auditStatus && auditStatus.statusType.toUpperCase() !== COMPLETED_SATUS)
    );
  });
   useEffect(() => {
    dispatch({
      type: SET_IS_COMPONENT_LOADED_FLAG,
      data: {
        isAuditPropertiesTargetSectionLoaded: true,
      },
    });
    return () => {
      dispatch({
        type: SET_IS_COMPONENT_LOADED_FLAG,
        data: {
          isAuditPropertiesTargetSectionLoaded: false,
        },
      });
    };
  }, []);

   useEffect(() => {
      dispatch(actions.asyncOperationStart(GET_TARGET_RATIONALE_LOOKUP_DATA));
    }, []);

  useEffect(() => {
    if (isSetTargetCodeValue) {
      if (isTargetTypeOfCode(auditPropertiesData?.targetType1)) {
        targetType1CodeValueInstance?.option(
          "value",
          auditPropertiesData?.targetValue1
        );
        setTimeout(() => {
          targetType1CodeValueInstance?.repaint();
        });
      }

      if (isTargetTypeOfCode(auditPropertiesData?.targetType2)) {
        targetType2CodeValueInstance?.option(
          "value",
          auditPropertiesData?.targetValue2
        );
        setTimeout(() => {
          targetType2CodeValueInstance?.repaint();
        });
      }

      dispatch({ type: SET_IS_SET_TARGET_CODE_VALUES, data: false });
    }
  }, [isSetTargetCodeValue]);

  const [taregtType1CodeDataSource, setTaregtType1CodeDataSource] = useState(
    []
  );
  const [taregtType2CodeDataSource, setTaregtType2CodeDataSource] = useState(
    []
  );

  const auditModeValue = useSelector(
    (state) => state["externalAuditReducer"].auditModeValue,
    isEqual
  );
  const initialRound = useSelector(
    (state) =>
      state["externalAuditReducer"].eaAuditRounds?.find(
        (x) => x.sequenceNo === 1
      ),
    isEqual
  );
  useEffect(() => {
    if (auditPropertiesData.targetType1 === "APR_DRG") {
      ddlTargetType1CodeValueDatasource.store.load();
    }
  }, [auditPropertiesData.targetType1]);
  useEffect(() => {
    if (auditPropertiesData.targetType2 === "APR_DRG") {
      ddlTargetType2CodeValueDatasource.store.load();
    }
  }, [auditPropertiesData.targetType2]);


  useEffect(() =>{
    if (auditPropertiesData.targetType2) {
      if (auditPropertiesData.targetType2.toLowerCase() === "other") {
        setIsTargetType2Other(true);
        setIsTargetType2Provider(false);
        setTargetType2PatientType(false);
      } else if (auditPropertiesData.targetType2.toLowerCase() === "provider") {
        setIsTargetType2Other(false);
        setIsTargetType2Provider(true);
        setTargetType2PatientType(false);
      } else if (auditPropertiesData.targetType2.toLowerCase() === "pt") {
        setTargetType2PatientType(true);
        setIsTargetType2Other(false);
        setIsTargetType2Provider(false);
      } else {
        setIsTargetType2Other(false);
        setIsTargetType2Provider(false);
        setTargetType2PatientType(false);
      }
      if(targetType2Lookup && patientTypes){
        let filtereditem =
        targetType2Lookup &&
        targetType2Lookup.filter(
          (x) => x.value === auditPropertiesData.targetType2
        );
        let codeTypeValue = filtereditem[0]?.codeType;
        if (codeTypeValue && codeTypeValue?.toLowerCase() !== "pt") {
        } else {
          dispatch({
            type: SET_TARGET_TYPE_VALUE_DATA_SOURCE,
            targetType2ValueSource: patientTypes,
            currentTagetType: 2,
            codeTypeValue: codeTypeValue,
          });
        }
      }
    }
  }, [auditPropertiesData.targetType2, props.targetType2Lookup, patientTypes])

  useEffect(() =>{
    if (auditPropertiesData.targetType1) {
      setTargetType1Selected(true);

      if (auditPropertiesData.targetType1?.toLowerCase() === "other") {
        setIsTargetTypeOther(true);
        setIsTargetTypeProvider(false);
        setTargetTypePatientType(false);
      } else if (auditPropertiesData.targetType1?.toLowerCase() === "provider") {
        setIsTargetTypeOther(false);
        setIsTargetTypeProvider(true);
        setTargetTypePatientType(false);
      } else if (auditPropertiesData.targetType1?.toLowerCase() === "pt") {
        setTargetTypePatientType(true);
        setIsTargetTypeOther(false);
        setIsTargetTypeProvider(false);
      } else {
        setIsTargetTypeOther(false);
        setIsTargetTypeProvider(false);
        setTargetTypePatientType(false);
      }

      if(targetTypeLookup && patientTypes){
        let filtereditem =
        targetTypeLookup &&
        targetTypeLookup.filter((x) => x.value === auditPropertiesData.targetType1);
        let codeTypeValue = filtereditem[0]?.codeType;
        if (codeTypeValue && codeTypeValue?.toLowerCase() !== "pt") {
        } else {
          dispatch({
            type: SET_TARGET_TYPE_VALUE_DATA_SOURCE,
            targetType1ValueSource: patientTypes,
            currentTagetType: 1,
            codeTypeValue: codeTypeValue,
          });
        }
      }

      if (auditPropertiesData.targetType1) {
        dispatch({
          type: SET_TARGET_TYPE_SELECTION,
          targetType1Selection: auditPropertiesData.targetType1,
        });
      }
    } else {
      setTargetType1Selected(false);
    }
  }, [auditPropertiesData.targetType1, props.targetTypeLookup, patientTypes])

  const ddlTargetType1CodeValueDatasource = useMemo(() => {
    return {
      store: new CustomStore({
        key: "code",
        load: (loadOptions) => {
          return new Promise((resolve) => {
            const codeType = targetTypeLookup.find(
              (x) => x.value === auditPropertiesData.targetType1
            ).codeType;
            if (
              codeType &&
              (loadOptions.searchValue?.length > 2 ||
                ((codeType?.toUpperCase() === "DRG_SERVICE_TYPE" ||
                  codeType?.toUpperCase() === "MODIFIER" ||
                  codeType?.toUpperCase() === "PLACE_OF_SERVICE") &&
                  loadOptions.searchValue?.length > 0) ||
                ((codeType?.toUpperCase() === "ICD_DIAGNOSIS" ||
                  codeType?.toUpperCase() === "ICD_PROCEDURE") &&
                  loadOptions.searchValue?.length > 1) ||
                ((codeType?.toUpperCase() === "FACILITY" ||
                  codeType?.toUpperCase() === "RENDERING_PROVIDER_GROUP") &&
                  loadOptions.searchValue?.length > 0))
            ) {
              dispatch({
                type: SHOW_LOADER,
                data: { isDisableFocusState: true },
              });
              callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                CodeType: codeType,
                CodeSearchStr: loadOptions.searchValue,
                SelectedCodeList: targetType1CodeValueInstance?.option("value"),
                fromServiceDate: new Date(
                  auditPropertiesData.serviceFromDate ?? new Date()
                ),
                toServiceDate: new Date(
                  auditPropertiesData.serviceToDate ?? new Date()
                ),
                AuditGroupId: auditPropertiesData.auditGroupId,
                EaAuditId: auditPropertiesData.eaAuditId,
              }).then((result) => {
                dispatch({
                  type: HIDE_LOADER,
                  data: { isDisableFocusState: false },
                });
                setTaregtType1CodeDataSource(result);
                resolve({
                  data: result,
                  totalCount: result?.length,
                });
              });
            } else if (
              codeType &&
              (!loadOptions.searchValue ||
                Object.keys(loadOptions).some((x) =>
                  ["filter", "customQueryParams", "expand", "select"].includes(
                    x
                  )
                ))
            ) {
              if (
                !["OTHER", "PT"].includes(codeType) &&
                auditPropertiesData.eaAuditId
              ) {
                dispatch({
                  type: SHOW_LOADER,
                  data: { isDisableFocusState: true },
                });
                if (
                  auditPropertiesData?.targetValue1DataSource &&
                  auditPropertiesData?.targetValue1DataSource?.length > 0
                ) {
                 handleTargetValueDataSource({
                   dataSource: auditPropertiesData?.targetValue1DataSource,
                   dispatch,
                   hideLoaderType: HIDE_LOADER,
                   setDataSource: setTaregtType1CodeDataSource,
                   resolve,
                   setPropertiesDataType: SET_AUDIT_PROPERTIES_DATA,
                   propertiesDataKey: "auditPropertiesData",
                   dataSourceKey: "targetValue1DataSource",
                 });
                 return;
                } else {
                  if (
                    loadOptions.filter?.length === 1 &&
                    loadOptions.filter[0].includes("contains")
                  ) {
                    loadOptions.searchValue = loadOptions.filter[0].pop();
                    const result = targetType1CodeValueInstance
                      .getDataSource()
                      .items();
                    resolve({
                      data: result,
                      totalCount: result?.length,
                    });
                    dispatch({
                      type: HIDE_LOADER,
                      data: { isDisableFocusState: true },
                    });
                    return;
                  }
                  callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                    CodeType: codeType,
                    fromServiceDate: new Date(
                      auditPropertiesData.serviceFromDate ?? new Date()
                    ),
                    toServiceDate: new Date(
                      auditPropertiesData.serviceToDate ?? new Date()
                    ),
                    CodeSearchStr: loadOptions.searchValue,
                    AuditGroupId: auditPropertiesData.auditGroupId,
                    SelectedCodeList: targetType1CodeValueInstance?.option(
                      "value"
                    ),
                    EaAuditId: auditPropertiesData.eaAuditId,
                  }).then((result) => {
                    dispatch({
                      type: HIDE_LOADER,
                      data: { isDisableFocusState: false },
                    });
                    setTaregtType1CodeDataSource(result);
                    resolve({
                      data: result,
                      totalCount: result?.length,
                    });
                  });
                }
              } else {
                resolve({
                  data: [],
                  totalCount: 0,
                });
              }
            } else {
              resolve({
                data: [],
                totalCount: 0,
              });
            }
          });
        },
      }),
    };
  }, [
    targetTypeLookup?.length,
    targetType1Instance,
    targetType1CodeValueInstance,
    auditPropertiesData.targetType1,
    auditPropertiesData.auditGroupId,
    auditPropertiesData.eaAuditId,
    auditPropertiesData.serviceFromDate,
    auditPropertiesData.serviceToDate,
   ]);
  const ddlTargetType2CodeValueDatasource = useMemo(() => {
    return {
      store: new CustomStore({
        key: "code",
        load: (loadOptions) => {
          return new Promise((resolve) => {
            const codeType = targetTypeLookup.find(
              (x) => x.value === auditPropertiesData.targetType2
            ).codeType;
            if (
              codeType &&
              (loadOptions.searchValue?.length > 2 ||
                ((codeType?.toUpperCase() === "DRG_SERVICE_TYPE" ||
                  codeType?.toUpperCase() === "MODIFIER" ||
                  codeType?.toUpperCase() === "PLACE_OF_SERVICE") &&
                  loadOptions.searchValue?.length > 0) ||
                ((codeType?.toUpperCase() === "ICD_DIAGNOSIS" ||
                  codeType?.toUpperCase() === "ICD_PROCEDURE") &&
                  loadOptions.searchValue?.length > 1) ||
                ((codeType?.toUpperCase() === "FACILITY" ||
                  codeType?.toUpperCase() === "RENDERING_PROVIDER_GROUP") &&
                  loadOptions.searchValue?.length > 0))
            ) {
              dispatch({
                type: SHOW_LOADER,
                data: { isDisableFocusState: true },
              });
              callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                CodeType: codeType,
                CodeSearchStr: loadOptions.searchValue,
                SelectedCodeList: targetType2CodeValueInstance?.option("value"),
                fromServiceDate: new Date(
                  auditPropertiesData.serviceFromDate ?? new Date()
                ),
                toServiceDate: new Date(
                  auditPropertiesData.serviceToDate ?? new Date()
                ),
                AuditGroupId: auditPropertiesData.auditGroupId,
                EaAuditId: auditPropertiesData.eaAuditId,
              }).then((result) => {
                dispatch({
                  type: HIDE_LOADER,
                  data: { isDisableFocusState: false },
                });
                setTaregtType2CodeDataSource(result);
                resolve({
                  data: result,
                  totalCount: result?.length,
                });
              });
            } else if (
              codeType &&
              (!loadOptions.searchValue ||
                Object.keys(loadOptions).some((x) =>
                  ["filter", "customQueryParams", "expand", "select"].includes(
                    x
                  )
                ))
            ) {
              if (
                !["OTHER", "PT"].includes(codeType) &&
                auditPropertiesData.eaAuditId
              ) {
                dispatch({
                  type: SHOW_LOADER,
                  data: { isDisableFocusState: true },
                });
                if (
                  auditPropertiesData?.targetValue2DataSource &&
                  auditPropertiesData?.targetValue2DataSource?.length > 0
                ) {
                  handleTargetValueDataSource({
                    dataSource: auditPropertiesData?.targetValue2DataSource,
                    dispatch,
                    hideLoaderType: HIDE_LOADER,
                    setDataSource: setTaregtType2CodeDataSource,
                    resolve,
                    setPropertiesDataType: SET_AUDIT_PROPERTIES_DATA,
                    propertiesDataKey: "auditPropertiesData",
                    dataSourceKey: "targetValue2DataSource",
                  });
                  return;
                } else {
                  if (
                    loadOptions.filter?.length === 1 &&
                    loadOptions.filter[0].includes("contains")
                  ) {
                    loadOptions.searchValue = loadOptions.filter[0].pop();
                    const result = targetType2CodeValueInstance
                      .getDataSource()
                      .items();
                    resolve({
                      data: result,
                      totalCount: result?.length,
                    });
                    dispatch({
                      type: HIDE_LOADER,
                      data: { isDisableFocusState: true },
                    });
                    return;
                  }
                  callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                    CodeType: codeType,
                    fromServiceDate: new Date(
                      auditPropertiesData.serviceFromDate ?? new Date()
                    ),
                    toServiceDate: new Date(
                      auditPropertiesData.serviceToDate ?? new Date()
                    ),
                    CodeSearchStr: loadOptions.searchValue,
                    AuditGroupId: auditPropertiesData.auditGroupId,
                    SelectedCodeList: targetType2CodeValueInstance?.option(
                      "value"
                    ),
                    EaAuditId: auditPropertiesData.eaAuditId,
                  }).then((result) => {
                    dispatch({
                      type: HIDE_LOADER,
                      data: { isDisableFocusState: false },
                    });
                    setTaregtType2CodeDataSource(result);
                    resolve({
                      data: result,
                      totalCount: result?.length,
                    });
                  });
                }
              } else {
                resolve({
                  data: [],
                  totalCount: 0,
                });
              }
            } else {
              resolve({
                data: [],
                totalCount: 0,
              });
            }
          });
        },
      }),
    };
  }, [
    targetTypeLookup?.length,
    targetType2Instance,
    targetType2CodeValueInstance,
    auditPropertiesData.targetType2,
    auditPropertiesData.auditGroupId,
    auditPropertiesData.eaAuditId,
    auditPropertiesData.serviceFromDate,
    auditPropertiesData.serviceToDate,

  ]);
  const validateClaimType = (e) => {
    return isAuditSafeToSave || (((eMDRDocumentId > 0 && auditModeValue === auditModes.CREATE) ||
      (props.selectedProcessTemplateRequiredFields &&
        props.selectedProcessTemplateRequiredFields.filter(
          (x) => x.eaRequiredFieldName?.toLowerCase() === CLAIM_TYPE
        ).length > 0)) &&
      !e.value
      ? false
      : true);
  };
  const validateTargetType = (e) => {
    return isAuditSafeToSave || (props.selectedProcessTemplateRequiredFields &&
      props.selectedProcessTemplateRequiredFields.filter(
        (x) => x.eaRequiredFieldName?.toLowerCase() === TARGET_TYPE
      ).length > 0 &&
      !e.value
      ? false
      : true);
  };
  const validateTargetValue = (e) => {
    return isAuditSafeToSave || (props.selectedProcessTemplateRequiredFields &&
      props.selectedProcessTemplateRequiredFields.filter(
        (x) => x.eaRequiredFieldName?.toLowerCase() === TARGET_VALUE
      ).length > 0 &&
      !e.value
      ? false
      : true);
  };

  const oldAuditPropertiesObject = useSelector(
    (state) => state["auditPropertiesReducer"].oldAuditPropertiesObject,
    isEqual
  );
  const onCancelClaimTypeWarning = (e) => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          claimTypeCd: oldAuditPropertiesObject.claimTypeCd,
        },
      },
    });
  };

  const roundsRequestersList = useSelector(
    (state) => state["externalAuditReducer"].roundsRequestersList,
    isEqual
  );
  const getRequesterInfo = (roundsRequestersList, initialRound) => {
    return roundsRequestersList?.find(
      (x) => x.eaRequesterId == initialRound?.requesterId
    );
  };

  const requesterInfo = useMemo(
    () => getRequesterInfo(roundsRequestersList, initialRound),
    [roundsRequestersList, initialRound]
  );

  const initialRequesterList = useMemo(() => {
    if (requesterData?.length > 0) {
      var selectedRequester = requesterData?.find(
        (x) => x.eaRequesterId == auditPropertiesData?.eaRequesterId
      );
      var validRequester = requesterData?.filter((x) =>
        x.termDate
          ? compareDates(x.termDate, new Date()) == 1
            ? true
            : false
          : true && x.activeInd
      );
      if (
        selectedRequester?.eaRequesterId > 0 &&
        auditPropertiesData?.eaRequesterId > 0 &&
        !validRequester.find((x) => {
          return x.eaRequesterId == selectedRequester?.eaRequesterId;
        })
      ) {
        selectedRequester.activeInd = false;
        validRequester.push(selectedRequester);
        return validRequester;
      } else {
        return validRequester;
      }
    }
  }, [requesterData, auditPropertiesData?.eaRequesterId]);

  const eaCaseListData = useSelector(
    (state) => state["caseListReducer"].eaCaseListData[0]?.caseList,
    isEqual
  );

  const isClaimTypeWarningPopupVisible = useSelector(
    (state) => state["auditPropertiesReducer"].isClaimTypeWarningPopupVisible,
    isEqual
  );

  const eaRoundProperties = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );
  const requesterList =  useSelector(
    (state) => state["auditPropertiesReducer"].requesterList,
    isEqual
  );
  const validContentTypes = useSelector(
    (state) => state["auditPropertiesReducer"].validContentTypes,
    isEqual
  );
  const contentTypeList =  useSelector(
    (state) => state["auditPropertiesReducer"].contentTypeList,
    isEqual
  );
  const onContentTypeClick = () => {
    window.open("/externalaudit/admin/contenttypes", "_blank");
  }
  const auditStatus = useSelector(
    (state) => state["auditPropertiesReducer"].auditStatus,
    isEqual
  );
  const processTemplateClaimTypeCd = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData.processTemplateClaimTypeCd,
    isEqual
  );

  const isReviewContractorValidForRequester = useMemo(()=>{
    if(!(eaRoundProperties?.length > 1) && auditPropertiesData?.statusId != auditStatus?.find(x=>x.statusCd == "Completed")?.statusId){
    var initialRequesterId = auditPropertiesData?.eaRequesterId;
    var initialContentType = auditPropertiesData?.eaContentTypeId;
      if ( reviewContractorList?.length > 0 && initialRequesterList?.length > 0 && initialRequesterId > 0) {
        var requester = initialRequesterList?.find((obj) => {
          return obj.eaRequesterId === initialRequesterId;
        });
        if (requester && requester.recordSubmissionMethod == "ESMD") {
          var reviewContractor = reviewContractorList?.find(
            (obj) => {
              return ( obj.reviewerCode === requester.recordSubmissionValue);
            }
          );
        }
        else{
          dispatch({
            type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
            data: true,
          });
          if(initialRound?.rqstrRecordSubmissionMethod?.toLowerCase() == "esmd"){
            var reviewContractor = reviewContractorList?.find(
              (obj) => {
                return ( obj.reviewerCode === initialRound?.rqstrRecordSubmissionValue);
              }
            );
             if(reviewContractor!=null){
              for(var key in reviewContractorContentTypeList) {
              if(key == reviewContractor.reviewContractorId)
              {
                var validContentTypes = reviewContractorContentTypeList[key];
                break;
              }
            }
           }
            dispatch({
              type: SET_VALID_INITIAL_CONTENT_TYPE_LIST,
              data: { validContentTypes:validContentTypes||[]},
            });
          }
          else{
            dispatch({
              type: SET_VALID_INITIAL_CONTENT_TYPE_LIST,
              data: { validContentTypes:[]},
            });
          }
          return true;
        }
        if (!reviewContractor.activeInd && requester.recordSubmissionValue == initialRound?.rqstrRecordSubmissionValue) {
          dispatch({
            type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
            data: false,
          });
          dispatch({
            type: SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
            data: true,
          });
          for(var key in reviewContractorContentTypeList) {
            if(key == reviewContractor.reviewContractorId)
            {
              var validContentTypes = reviewContractorContentTypeList[key];
              break;
            }
          }
          dispatch({
            type: SET_VALID_INITIAL_CONTENT_TYPE_LIST,
            data: { validContentTypes:validContentTypes},
          });
          return false;
        }
        else {
          for(var key in reviewContractorContentTypeList) {
            if(key == reviewContractor.reviewContractorId)
            {
              var contentTypes = reviewContractorContentTypeList[key];
              var validContentTypes = contentTypes.filter((x)=>{return x.activeInd});
              break;
            }
          }
          if(validContentTypes){
            var contentType = validContentTypes.find((obj) => {
              return obj.eaContentTypeId === initialContentType;
            });
          }
          if(!contentType && initialContentType){
            var invalidContentType = contentTypeList.find((obj)=>{
              return obj.eaContentTypeId == initialContentType;
            })
            invalidContentType.activeInd = false;
            if(!(validContentTypes.find((x)=>{return x.eaContentTypeId == initialContentType}))){
              validContentTypes.push(invalidContentType);
            }
            dispatch({
              type: SET_VALID_INITIAL_CONTENT_TYPE_LIST,
              data: { validContentTypes:validContentTypes},
            });
            dispatch({
              type: SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
              data: false,
            });
          }
          else{
            dispatch({
              type: SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
              data: true,
            });
            dispatch({
              type: SET_VALID_INITIAL_CONTENT_TYPE_LIST,
              data: { validContentTypes:validContentTypes},
            });
          }
          dispatch({
            type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
            data: true,
          });
          return true;
        }
      }
      else{
        dispatch({
          type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
          data: true,
        });
        dispatch({
          type: SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
          data: true,
        });
        return true;
      }
    }
    else{
      dispatch({
        type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
        data: true,
      });
      dispatch({
        type: SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
        data: true,
      });
      return true;
    }
  },[reviewContractorList?.length,
    initialRequesterList?.length,
    auditPropertiesData?.eaRequesterId,
    auditPropertiesData?.eaContentTypeId,
    auditModeValue,
    auditPropertiesData?.statusId,
    auditStatus?.length
  ]);

  const toggleEditRequesterPermissionAlertPopupVisible = (isVisible) => {
    dispatch({
      type: TOGGLE_EDIT_REQUESTER_ALERT_POPUP,
      data: {
        isEditRequesterAlertPopupVisible: isVisible,
      },
    });
  };
  let eMDRDocumentId = 0;
  const currentUrlSearchParams = new URLSearchParams(
    window.location.href.split("?")[1]
  );
  for (let parameterPair of currentUrlSearchParams.entries() as any) {
    if (
      parameterPair.length > 0 &&
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "documentid"
    ) {
      eMDRDocumentId = parseInt(parameterPair[1]);
    }
  }
  let claimTypes = [];
  if (eMDRDocumentId > 0 && auditModeValue === auditModes.CREATE) {
    claimTypes = props.claimTypes?.filter((x) => x.code !== "A");
  } else {
    claimTypes = props.claimTypes;
  }
  return (
    <div>
      <EditRequesterPermissionAlertPopup
        toggleEditRequesterPermissionAlertPopupVisible={
          toggleEditRequesterPermissionAlertPopupVisible
        }
      />
      <div className="subsection-title application-section-primary-background-color ">
        Target Data
      </div>
      <div className="section-padding">
        <div
          className={
            props?.isExternalAuditReadOnly ? "mdae-readonly-content" : ""
          }
        >
          <div
            className={
              isInitialReviewContractorInvalidForRequester ||
              auditModeValue === auditModes.EDIT
                ? ""
                : "invalid-initial-review-contractor"
            }
          >
            <MdaeSelectBox
              required={true}
              id={"ddlRequester"}
              tabIndex={11}
              elementAttr={{
                title:
                  isInitialReviewContractorInvalidForRequester ||
                  auditModeValue === auditModes.EDIT
                    ? ""
                    : "This Requester contains a Review Contractor that is no longer valid. Please update the Review Contractor for your Requester here.",
              }}
              mdaeDropDownBoxTitle={
                eaRoundProperties?.length > 1
                  ? "Initial Requester Organization Name"
                  : isInitialReviewContractorInvalidForRequester ||
                    auditModeValue === auditModes.EDIT
                  ? "Initial Requester Organization Name"
                  : () => {
                      return (
                        <span id="inValidRequester">
                          Initial Requester Organization Name
                          <span>
                            <RequiredFieldLabel />
                          </span>
                          <u>
                            <a
                              onMouseEnter={() => {
                                $("#inValidRequester").css("cursor", "pointer");
                              }}
                              onClick={() => {
                                if (requesterPermissions.hasUpdateAccess) {
                                  window.open(
                                    "/externalaudit/admin/requesterandsource?eaRequesterId=" +
                                      (auditModeValue === auditModes.CREATE
                                        ? auditPropertiesData?.eaRequesterId
                                        : initialRound?.requesterId) +
                                      "&organizationName=" +
                                      initialRound?.rqstrOrganizationName,
                                    "_blank"
                                  );
                                } else {
                                  toggleEditRequesterPermissionAlertPopupVisible(
                                    true
                                  );
                                }
                              }}
                              style={{ marginLeft: "5px" }}
                            >
                              Edit
                            </a>
                          </u>
                        </span>
                      );
                    }
              }
              readOnly={auditModeValue === auditModes.EDIT}
              dataSource={initialRequesterList}
              isValid={
                isReviewContractorValidForRequester ||
                auditModeValue === auditModes.EDIT
              }
              displayExpr={"organizationName"}
              valueExpr={"eaRequesterId"}
              value={auditPropertiesData?.eaRequesterId}
              onValueChanged={(e) => {
                if (e.event || auditModeValue === auditModes.CREATE) {
                  if (auditModeValue === auditModes.CREATE) {
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: {
                          eaRequesterId: e.value,
                        },
                      },
                    });
                  } else {
                    dispatch({
                      type: SET_CURRENT_ROUND_DATA,
                      data: {
                        eaAuditRound: {
                          index: 0,
                          requesterId: e.value,
                        },
                      },
                    });
                  }
                  callOperation(GET_EA_REQUESTER_BY_ID, {
                    requesterId: e.value,
                  }).then((response) => {
                    const shouldSetClaim = dispatch(shouldSetClaimType);
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: {
                          ...(shouldSetClaim && claimTypes.some(ct => ct.code === response?.claimTypeCd) && isEmpty(processTemplateClaimTypeCd) && {
                            claimTypeCd: response.claimTypeCd
                          }),
                          ...(shouldSetClaim && claimTypes.some(ct => ct.code === response?.claimTypeCd) && {
                            requesterClaimType:response.claimTypeCd
                          }),
                          eaSourceId: response.eaSourceId,
                          rqstrRecordSubmissionMethod:
                            response?.rqstrRecordSubmissionMethod,
                            
                        },
                      },
                    });

                    if (auditModeValue === auditModes.EDIT) {
                      dispatch({
                        type: SET_CURRENT_ROUND_DATA,
                        data: {
                          eaAuditRound: {
                            index: 0,
                            rqstrOrganizationName:
                              response?.rqstrOrganizationName,
                            rqstrMainPhoneNumber:
                              response?.rqstrMainPhoneNumber,
                            rqstrMainEmail: response?.rqstrMainEmail,
                            rqstrContactName: response?.rqstrContactName,
                            rqstrContactPhoneNumber:
                              response?.rqstrContactPhoneNumber,
                            rqstrContactEmail: response?.rqstrContactEmail,
                            rqstrNotes: response?.rqstrNotes,
                            rqstrRecordSubmissionMethod:
                              response?.rqstrRecordSubmissionMethod,
                            rqstrRecordSubmissionValue:
                              response?.rqstrRecordSubmissionValue,
                            claimTypeCd: response?.claimTypeCd,
                            eaSourceId: response?.eaSourceId,
                            requesterId: e.value,
                          },
                        },
                      });
                    }
                  });
                }
              }}
            >
              <Validator validationGroup={props.auditPropertiesValidationGroup}>
                <RequiredRule message="Initial Requester Organization Name is required" />
                <CustomRule
                  validationCallback={(e) => {
                    if (
                      !(eaRoundProperties?.length > 1) &&
                      auditPropertiesData?.statusId !=
                        auditStatus?.find((x) => x.statusCd == "Completed")
                          ?.statusId &&
                      auditModeValue === auditModes.CREATE
                    ) {
                      if (
                        reviewContractorList?.length > 0 &&
                        initialRequesterList?.length > 0 &&
                        e.value
                      ) {
                        var requester = initialRequesterList.find((obj) => {
                          return obj.eaRequesterId === e.value;
                        });
                        if (
                          requester &&
                          requester.recordSubmissionMethod == "ESMD"
                        ) {
                          var validRequester = reviewContractorList?.find(
                            (obj) => {
                              return (
                                obj.reviewerCode ===
                                requester.recordSubmissionValue
                              );
                            }
                          );
                        }
                        if (
                          validRequester &&
                          !validRequester.activeInd &&
                          validRequester.reviewerCode ==
                            initialRound?.rqstrRecordSubmissionValue
                        ) {
                          dispatch({
                            type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
                            data: false,
                          });
                          return false;
                        } else {
                          dispatch({
                            type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
                            data: true,
                          });
                          return true;
                        }
                      }
                    } else {
                      dispatch({
                        type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER,
                        data: true,
                      });
                      return true;
                    }
                  }}
                />
              </Validator>
            </MdaeSelectBox>
          </div>

          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlSource"}
              tabIndex={12}
              mdaeDropDownBoxTitle={"Initial Source"}
              displayExpr={"eaSourceName"}
              readOnly={auditModeValue === auditModes.EDIT}
              madeFieldTitleClassName={
                initialRound?.requesterId > 0 &&
                auditPropertiesData?.eaSourceId &&
                !isEqual(
                  requesterInfo?.eaSourceId,
                  auditPropertiesData?.eaSourceId
                )
                  ? "mdae-text-box-field-set-italic"
                  : ""
              }
              valueExpr={"eaSourceId"}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_AUDIT_PROPERTIES_DATA,
                  reducerName: "auditPropertiesReducer",
                  widgetOptionBindings: {
                    value: "auditPropertiesData.eaSourceId",
                  },
                },
                {
                  actionType: GET_TARGET_DATA_LOOKUPS,
                  isAsyncComplete: true,
                  widgetOptionBindings: {
                    dataSource: "sorcesList",
                  },
                },
              ]}
            ></MdaeSelectBox>
          </div>
          {auditModeValue === auditModes.CREATE &&
            auditPropertiesData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
              "esmd" && (
              <div
                className={
                  isInitialContentTypeInvalidForReviewContractor
                    ? "widget-separation-margin-top content-type-field"
                    : "widget-separation-margin-top content-type-field invalid-initial-content-type"
                }
              >
                <MdaeSelectBox
                  required={true}
                  id={"ddlInitialContentType"}
                  tabIndex={11}
                  mdaeDropDownBoxTitle={"Initial Content Type"}
                  width={"450"}
                  readOnly={auditModeValue === auditModes.EDIT}
                  isValid={isInitialContentTypeInvalidForReviewContractor}
                  itemRender={(item) => {
                    if (item.activeInd) {
                      return (
                        item &&
                        item.eaContentTypeCode +
                          " - " +
                          item.eaContentTypeDescription
                      );
                    }
                  }}
                  displayExpr={(item) => {
                    return (
                      item &&
                      item.eaContentTypeCode +
                        " - " +
                        item.eaContentTypeDescription
                    );
                  }}
                  elementAttr={{
                    title: isInitialContentTypeInvalidForReviewContractor
                      ? ""
                      : "The selected Content Type is no longer valid for the Review Contractor associated with this Requester. Please update your Content Type selection.",
                  }}
                  valueExpr={"eaContentTypeId"}
                  value={auditPropertiesData?.eaContentTypeId}
                  onValueChanged={(e) => {
                    if (auditModeValue === auditModes.CREATE) {
                      dispatch({
                        type: SET_AUDIT_PROPERTIES_DATA,
                        data: {
                          auditPropertiesData: {
                            eaContentTypeId: e.value,
                          },
                        },
                      });
                    } else {
                      dispatch({
                        type: SET_CURRENT_ROUND_DATA,
                        data: {
                          eaAuditRound: {
                            index: 0,
                            eaContentTypeId: e.value,
                          },
                        },
                      });
                      dispatch({
                        type: SET_AUDIT_PROPERTIES_DATA,
                        data: {
                          auditPropertiesData: {
                            eaContentTypeId: e.value,
                          },
                        },
                      });
                    }
                  }}
                  dataSource={validContentTypes}
                >
                  <Validator
                    validationGroup={props.auditPropertiesValidationGroup}
                  >
                    <RequiredRule message="Initial content type is required" />
                  </Validator>
                </MdaeSelectBox>
                {auditModeValue === auditModes.CREATE ? (
                  auditPropertiesData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
                  "esmd" ? (
                    <span
                      className="case-search-info-icon content-type-field-icon"
                      title={
                        "Click here to open the Content Maintenance page for more information"
                      }
                      onClick={onContentTypeClick}
                    >
                      <i className="img-circle fa fa-info-circle account-case-search-info-circle"></i>
                    </span>
                  ) : null
                ) : initialRound?.rqstrRecordSubmissionMethod?.toLowerCase() ===
                  "esmd" ? (
                  <span
                    className="case-search-info-icon content-type-field-icon"
                    title={
                      "Click here to open the Content Maintenance page for more information"
                    }
                    onClick={onContentTypeClick}
                  >
                    <i className="img-circle fa fa-info-circle account-case-search-info-circle"></i>
                  </span>
                ) : null}
              </div>
            )}
          <div className={"widget-separation-margin-top align-items-center flex-container"}>
            <div className="field-width-48">
              <MdaeSelectBox
                id={"ddlClaimType"}
                tabIndex={13}
                required={
                  (eMDRDocumentId > 0 &&
                    auditModeValue === auditModes.CREATE) ||
                  (props.selectedProcessTemplateRequiredFields &&
                    props.selectedProcessTemplateRequiredFields.filter(
                      (x) => x.eaRequiredFieldName?.toLowerCase() === CLAIM_TYPE
                    ).length > 0)
                    ? true
                    : false
                }
                mdaeDropDownBoxTitle={"Claim Type"}
                madeFieldTitleClassName={
                  initialRound?.requesterId > 0 &&
                  auditPropertiesData?.claimTypeCd &&
                  !isEqual(
                    requesterInfo?.claimTypeCd,
                    auditPropertiesData?.claimTypeCd
                  )
                    ? "mdae-text-box-field-set-italic"
                    : ""
                }
                displayExpr={"description"}
                valueExpr={"code"}
                dataSource={claimTypes}
                onValueChanged={(e) => {
                  if (e.value) {
                    dispatch({ type: SHOW_LOADER });
                    callOperation(GET_CODE_TYPES_LOOKUPS, {}).then(
                      (response) => {
                        let filterdValue =
                          e.value === PROFESSIONAL
                            ? response.targetTypesList.filter(
                                (x) =>
                                  x.displayName.toLocaleLowerCase() !==
                                    "icd procedure" &&
                                  x.displayName.toLocaleLowerCase() !== "drg"
                              )
                            : response.targetTypesList;
                        dispatch({
                          type: SET_TARGET_TYPES_LOOKUP,
                          targetTypes: filterdValue,
                          currentTagetType: 1,
                        });
                        dispatch({
                          type: SET_TARGET_TYPES_LOOKUP,
                          targetTypes2: filterdValue,
                          currentTagetType: 2,
                        });
                        dispatch({ type: HIDE_LOADER });
                      }
                    );

                    let count = eaCaseListData?.filter(
                      (x) =>
                        x.claimTypeCd?.toUpperCase() !==
                          auditPropertiesData?.claimTypeCd?.toUpperCase() &&
                        auditPropertiesData?.claimTypeCd?.toUpperCase() !== "A"
                    );
                    if (
                      e.event &&
                      props.mode === auditModes.EDIT &&
                      count?.length > 0
                    ) {
                      toggleClaimTypeWarningPopup(true, dispatch);
                    }
                  }
                }}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                      value: "auditPropertiesData.claimTypeCd",
                    },
                  },
                ]}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <CustomRule
                    message="Claim Type is required"
                    validationCallback={validateClaimType}
                  />
                </Validator>
              </MdaeSelectBox>
            </div>
            <div className="field-width-48">
              <MdaeSelectBox
                id={"ddlEaAuditType"}
                tabIndex={13.5}
                mdaeDropDownBoxTitle={"Audit Type"}
                displayExpr={"description"}
                valueExpr={"code"}
                dataSource={eaAuditTypes}
                required
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                      value: "auditPropertiesData.eaAuditType",
                    },
                  },
                ]}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <RequiredRule message="Audit Type is required" />
                </Validator>
              </MdaeSelectBox>
            </div>
          </div>
          <div className={"widget-separation-margin-top  align-items-center flex-container"}>
            <div className="field-width-48">
              <MdaeDateBox
                id="dtService From"
                tabIndex={15}
                required
                mdaeDateBoxTitle="Service From"
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                      value: "auditPropertiesData.serviceFromDate",
                    },
                  },
                ]}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <RequiredRule message="Service From is required" />
                </Validator>
              </MdaeDateBox>
            </div>
            <div className="field-width-48">
              <MdaeDateBox
                id="dtServiceTo"
                tabIndex={16}
                required
                mdaeDateBoxTitle="Service To"
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                      value: "auditPropertiesData.serviceToDate",
                    },
                  },
                ]}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <RequiredRule message="Service To Date is required" />
                </Validator>
              </MdaeDateBox>
            </div>
          </div>
          <div className="widget-separation-margin-top  align-items-center flex-container">
            <div className="field-width-48">
            <MdaeSelectBox
              id={"ddlRoundLineLevel"}
              tabIndex={16.5}
              mdaeDropDownBoxTitle={"Round Line Level"}
              dataSource={auditRLLODataSource}
              displayExpr={"name"}
              valueExpr={"id"}
              mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                        value: "auditPropertiesData.isRoundLineLevelTrackingEnabled",
                    },
                  },
                ]}
            ></MdaeSelectBox>
            </div>
          </div>
          <div className="widget-separation-margin-top">
            <MdaeTagBox
              id={"ddlTargetRationale"}
              tabIndex={17}
              mdaeTagBoxTitle={"Target Rationale"}
              displayExpr={"name"}
              searchEnabled={true}
              showSelectionControls={true}
              valueExpr={"value"}
              dataSource={sortSelectedItemsOnTop(
                auditTargetRationaleList,
                auditPropertiesData.targetRationaleValue
              )}
              onValueChanged={(e) => {
                if (e.event) {
                  const value = (e.value || []).map(Number);
                  dispatch({
                    type: SET_AUDIT_PROPERTIES_DATA,
                    data: {
                      auditPropertiesData: {
                        targetRationaleValue: value,
                      },
                    },
                  });
                }
              }}
              value={(Array.isArray(auditPropertiesData.targetRationaleValue)
                ? auditPropertiesData.targetRationaleValue
                : []
              ).map(Number)}
            ></MdaeTagBox>
          </div>
          <div className="widget-separation-margin-top">
            <MdaeSelectBox
              id={"ddlTargetType"}
              tabIndex={18}
              required={
                props.selectedProcessTemplateRequiredFields &&
                props.selectedProcessTemplateRequiredFields.filter(
                  (x) => x.eaRequiredFieldName?.toLowerCase() === TARGET_TYPE
                ).length > 0
                  ? true
                  : false
              }
              onInitialized={(e) => {
                setTargetType1Instance(e.component);
              }}
              mdaeDropDownBoxTitle={"Target Type 1"}
              displayExpr={"displayName"}
              valueExpr={"value"}
              dataSource={targetTypeLookup}
              onValueChanged={(e) => {
                if (e.event) {
                  dispatch({
                    type: SET_AUDIT_PROPERTIES_DATA,
                    data: {
                      auditPropertiesData: {
                        targetType1: e.value,
                        targetValue1: null,
                      },
                    },
                  });
                  setTaregtType1CodeDataSource([]);
                }
              }}
              value={auditPropertiesData.targetType1}
            >
              <Validator validationGroup={props.auditPropertiesValidationGroup}>
                <CustomRule
                  message="Target Type is required"
                  validationCallback={validateTargetType}
                />
              </Validator>
            </MdaeSelectBox>
          </div>
          {auditPropertiesData?.targetType1?.toLowerCase() != "other" &&
            !isTargetTypePatientType && (
              <div className="widget-separation-margin-top">
                {targetType1Instance?.option("selectedItem")?.codeType ==
                  "APR_DRG" &&
                taregtType1CodeDataSource.every(
                  (x) => Boolean(x.isCodeReferencedFromCase) === false
                ) ? (
                  <MdaeTextArea
                    id="txtTargetValue"
                    tabIndex={20}
                    mdaeTextAreaTitle="Target Value 1"
                    height={60}
                    maxLength={200}
                    placeholder="Enter number with commas"
                    value={auditPropertiesData.targetValue1}
                    onValueChanged={(e) => {
                      if (e.value) {
                        dispatch({
                          type: SET_AUDIT_PROPERTIES_DATA,
                          data: {
                            auditPropertiesData: { targetValue1: e.value },
                          },
                        });
                      }
                    }}
                  >
                    <Validator
                      validationGroup={props.auditPropertiesValidationGroup}
                    >
                      <PatternRule
                        message="Only numbers and commas are allowed"
                        pattern={/^[0-9,]*$/}
                      ></PatternRule>
                    </Validator>
                  </MdaeTextArea>
                ) : (
                  <>
                    {auditPropertiesData?.targetType1?.toLowerCase() !=
                      "other" &&
                      auditPropertiesData?.targetType1?.toLowerCase() !=
                        "pt" && (
                        <MdaeTagBox
                          id={"ddlTargetValue1"}
                          tabIndex={19}
                          required={
                            props.selectedProcessTemplateRequiredFields &&
                            props.selectedProcessTemplateRequiredFields.filter(
                              (x) =>
                                x.eaRequiredFieldName?.toLowerCase() ===
                                TARGET_VALUE
                            ).length > 0
                              ? true
                              : false
                          }
                          selectAllMode={"page"}
                          mdaeTagBoxTitle={"Target Value 1"}
                          displayExpr={
                            targetType1Instance?.option("selectedItem")
                              ?.codeType == "APR_DRG"
                              ? "code"
                              : "description"
                          }
                          valueExpr={"code"}
                          onInitialized={(e) => {
                            setTargetType1CodeValueInstance(e.component);
                          }}
                          searchEnabled={true}
                          showSelectionControls={true}
                          maxDisplayedTags={1}
                          value={
                            Array.isArray(auditPropertiesData.targetValue1)
                              ? auditPropertiesData.targetValue1
                              : typeof auditPropertiesData.targetValue1 ===
                                "string"
                              ? auditPropertiesData.targetValue1
                                  .split(",")
                                  .map((s) => s.trim())
                              : []
                          }
                          onValueChanged={(e) => {
                            if (e.value) {
                              dispatch({
                                type: SET_AUDIT_PROPERTIES_DATA,
                                data: {
                                  auditPropertiesData: {
                                    targetValue1: e.value,
                                  },
                                },
                              });
                            }
                          }}
                          dataSource={ddlTargetType1CodeValueDatasource}
                        >
                          <Validator
                            validationGroup={
                              props.auditPropertiesValidationGroup
                            }
                          >
                            <CustomRule
                              message="Target Value is required"
                              validationCallback={validateTargetValue}
                            />
                          </Validator>
                        </MdaeTagBox>
                      )}
                  </>
                )}
              </div>
            )}

          {auditPropertiesData?.targetType1?.toLowerCase() === "other" && (
            <div className="widget-separation-margin-top">
              <MdaeTextArea
                id="txtTargetValue"
                tabIndex={20}
                mdaeTextAreaTitle="Target Value 1"
                height={60}
                maxLength={200}
                value={auditPropertiesData.targetValue1}
                onValueChanged={(e) => {
                  if (e.value) {
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: { targetValue1: e.value },
                      },
                    });
                  }
                }}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <CustomRule
                    message={invalidOrUnprintableCharMassage}
                    reevaluate
                    validationCallback={(params) =>
                      isPrintableAscii(params.value)
                    }
                  />
                </Validator>
              </MdaeTextArea>
            </div>
          )}
          {isTargetTypePatientType && (
            <div className="widget-separation-margin-top">
              <MdaeSelectBox
                id={"ddlTargetValue1"}
                tabIndex={21}
                required={
                  props.selectedProcessTemplateRequiredFields &&
                  props.selectedProcessTemplateRequiredFields.filter(
                    (x) => x.eaRequiredFieldName?.toLowerCase() === TARGET_VALUE
                  ).length > 0
                    ? true
                    : false
                }
                mdaeDropDownBoxTitle={"Target Value 1"}
                displayExpr={"description"}
                valueExpr={"code"}
                dataSource={targetType1ValueSource}
                value={auditPropertiesData.targetValue1}
                onValueChanged={(e) => {
                  if (e.value) {
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: { targetValue1: e.value },
                      },
                    });
                  }
                }}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                >
                  <CustomRule
                    message="Target Value 1 is required"
                    validationCallback={validateTargetValue}
                  />
                </Validator>
              </MdaeSelectBox>
            </div>
          )}

          {isTargetType1Selected && (
            <div className="widget-separation-margin-top">
              <MdaeSelectBox
                id={"ddlTargetType2"}
                tabIndex={22}
                onInitialized={(e) => {
                  setTargetType2Instance(e.component);
                }}
                mdaeDropDownBoxTitle={"Target Type 2"}
                displayExpr={"displayName"}
                valueExpr={"value"}
                dataSource={props.targetType2Lookup}
                value={auditPropertiesData.targetType2}
                onOpened={(e) => {
                  if (targetType1Instance?.option("value")) {
                    let filteredItems =
                      targetTypeLookup &&
                      targetTypeLookup.filter(
                        (x) => x.value != targetType1Instance?.option("value")
                      );
                    dispatch({
                      type: SET_TARGET_TYPES_LOOKUP,
                      targetTypes2: filteredItems,
                      currentTagetType: 2,
                    });
                  }
                }}
                onValueChanged={(e) => {
                  if (e.event) {
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: {
                          targetType2: e.value,
                          targetValue2: null,
                        },
                      },
                    });
                    setTaregtType2CodeDataSource([]);
                  }
                }}
              >
                <Validator
                  validationGroup={props.auditPropertiesValidationGroup}
                ></Validator>
              </MdaeSelectBox>
            </div>
          )}
          {auditPropertiesData?.targetType2?.toLowerCase() != "other" &&
            !isTargetType2PatientType &&
            isTargetType1Selected && (
              <div className="widget-separation-margin-top">
                {targetType2Instance?.option("selectedItem")?.codeType ==
                  "APR_DRG" &&
                taregtType2CodeDataSource.every(
                  (x) => Boolean(x.isCodeReferencedFromCase) === false
                ) ? (
                  <MdaeTextArea
                    id="txtTargetValue2"
                    tabIndex={24}
                    mdaeTextAreaTitle="Target Value 2"
                    height={60}
                    maxLength={200}
                    value={auditPropertiesData.targetValue2}
                    placeholder="Enter number with commas"
                    onValueChanged={(e) => {
                      if (e.value) {
                        dispatch({
                          type: SET_AUDIT_PROPERTIES_DATA,
                          data: {
                            auditPropertiesData: { targetValue2: e.value },
                          },
                        });
                      }
                    }}
                  >
                    <Validator
                      validationGroup={props.auditPropertiesValidationGroup}
                    >
                      <PatternRule
                        message="Only numbers and commas are allowed"
                        pattern={/^[0-9,]*$/}
                      ></PatternRule>
                    </Validator>
                  </MdaeTextArea>
                ) : (
                  <>
                    {auditPropertiesData?.targetType2?.toLowerCase() !=
                      "other" &&
                      auditPropertiesData?.targetType2?.toLowerCase() !=
                        "pt" && (
                        <MdaeTagBox
                          id={"ddlTargetValue2"}
                          tabIndex={23}
                          mdaeTagBoxTitle={"Target Value 2"}
                          displayExpr={
                            targetType2Instance?.option("selectedItem")
                              ?.codeType == "APR_DRG"
                              ? "code"
                              : "description"
                          }
                          valueExpr={"code"}
                          onInitialized={(e) => {
                            setTargetType2CodeValueInstance(e.component);
                          }}
                          value={
                            Array.isArray(auditPropertiesData.targetValue2)
                              ? auditPropertiesData.targetValue2
                              : typeof auditPropertiesData.targetValue2 ===
                                "string"
                              ? auditPropertiesData.targetValue2
                                  .split(",")
                                  .map((s) => s.trim())
                              : []
                          }
                          onValueChanged={(e) => {
                            if (e.value) {
                              dispatch({
                                type: SET_AUDIT_PROPERTIES_DATA,
                                data: {
                                  auditPropertiesData: {
                                    targetValue2: e.value,
                                  },
                                },
                              });
                            }
                          }}
                          showSelectionControls={true}
                          maxDisplayedTags={1}
                          selectAllMode={"page"}
                          dataSource={ddlTargetType2CodeValueDatasource}
                        >
                          <Validator
                            validationGroup={
                              props.auditPropertiesValidationGroup
                            }
                          ></Validator>
                        </MdaeTagBox>
                      )}
                  </>
                )}
              </div>
            )}

          {auditPropertiesData?.targetType2?.toLowerCase() === "other" &&
            isTargetType1Selected && (
              <div className="widget-separation-margin-top">
                <MdaeTextArea
                  id="txtTargetValue2"
                  tabIndex={24}
                  mdaeTextAreaTitle="Target Value 2"
                  height={60}
                  maxLength={200}
                  value={auditPropertiesData.targetValue2}
                  onValueChanged={(e) => {
                    if (e.value) {
                      dispatch({
                        type: SET_AUDIT_PROPERTIES_DATA,
                        data: {
                          auditPropertiesData: { targetValue2: e.value },
                        },
                      });
                    }
                  }}
                >
                  <Validator
                    validationGroup={props.auditPropertiesValidationGroup}
                  >
                    <CustomRule
                      message={invalidOrUnprintableCharMassage}
                      reevaluate
                      validationCallback={(params) =>
                        isPrintableAscii(params.value)
                      }
                    />
                  </Validator>
                </MdaeTextArea>
              </div>
            )}
          {auditPropertiesData?.targetType2?.toLowerCase() === "pt" &&
            isTargetType1Selected && (
              <div className="widget-separation-margin-top">
                <MdaeSelectBox
                  id={"ddlTargetValue2"}
                  tabIndex={25}
                  mdaeDropDownBoxTitle={"Target Value 2"}
                  displayExpr={"description"}
                  valueExpr={"code"}
                  dataSource={targetType2ValueSource}
                  value={auditPropertiesData.targetValue2}
                  onValueChanged={(e) => {
                    if (e.value) {
                      dispatch({
                        type: SET_AUDIT_PROPERTIES_DATA,
                        data: {
                          auditPropertiesData: { targetValue2: e.value },
                        },
                      });
                    }
                  }}
                >
                  <Validator
                    validationGroup={props.auditPropertiesValidationGroup}
                  ></Validator>
                </MdaeSelectBox>
              </div>
            )}
        </div>
      </div>
      {isClaimTypeWarningPopupVisible && (
        <ClaimTypeWarningPopup
          toggleClaimTypeWarningPopup={toggleClaimTypeWarningPopup}
          onCancelClaimTypeWarning={onCancelClaimTypeWarning}
        />
      )}
    </div>
  );
};

export default AuditPropertiesTargetDataSectionComponent;
